'use strict';

const computeFilterLegs = require('./compute_filter_legs');

const filterModelProps = require('./model_props');

const parseFilterData = function(filter, msg, index) {
    return Odigeo._.pick(msg.filtersMetadataAll[index], filterModelProps[filter]);
};

const parseAirportCollection = function(city) {
    return Odigeo._.map(city.airportsList, parseAirport);
};

const parseAirport = function(airport) {
    return {
        id: airport.id,
        iata: airport.iata,
        name: airport.name,
        active: airport.matchedItinerariesCount > 0,
    };
};

const parseCityCollection = function(msg, cityList, numOfMatches) {
    return Odigeo._.map(cityList, function(city, cityId) {
        return {
            id: cityId,
            name: city.searchedLocation.city,
            sameAirport: {
                visible: numOfMatches < msg.numResults && numOfMatches > 0,
            },
            airportCollection: parseAirportCollection(city),
        };
    });
};

const parseResetCityCollection = function(msg, index) {
    const fMetadata = msg.filtersMetadataAll[index];
    const numOfSameOriginMatches = fMetadata.returnSameOriginMetadata.matchedItinerariesCount;
    const numOfSameDestinationMatches = fMetadata.departSameDestinationMetadata.matchedItinerariesCount;

    return Odigeo._.extend(parseFilterData('airports', msg, index), {
        origin: parseCityCollection(msg, fMetadata.airportsByOrigins, numOfSameOriginMatches),
        destination: parseCityCollection(msg, fMetadata.airportsByDestinations, numOfSameDestinationMatches),
        stopoverAirports: Odigeo._.map(fMetadata.stopoversMetadata.itemsCollection, parseAirport),
    });
};

const parseAirlineCollection = function(msg, index) {
    const airlinesCollection =Odigeo._.map(msg.filtersMetadataAll[index].airlinesCollection, function(airline) {
        return {
            id: airline.code,
            code: airline.code,
            name: airline.name,
            active: airline.matchedItinerariesCount !== 0,
        };
    });
    return {
        airlinesCollection: airlinesCollection,
    };
};

const parseBaggage = function(msg) {
    return msg.filtersMetadataAll[0].baggageMetadata;
};

const parseStopoverDuration = function(msg, index) {
    return Odigeo._.extend(parseFilterData('stopoverDuration', msg, index), {
        filterModelStopDuration: msg.stopDurationFilterModel[index],
        numFilteredResults: msg.numFilteredResults,
    });
};

const parseTime = function(msg, index) {
    return Odigeo._.extend(parseFilterData('time', msg, index), {
        budget: msg.filtersMetadataAll[index].timeBudgetMetadata,
    });
};

const parseTimeRanges = function(msg, index) {
    return Odigeo._.extend(parseFilterData('timeRanges', msg, index), {
        ranges: msg.filtersMetadataAll[index].timeRangeDepartureMetadata.dateRanges,
        activeRanges: msg.filtersMetadataAll[index].timeRangeDepartureMetadata.activeRanges,
    });
};

const parserResetFunctions = {
    time: parseTime,

    airports: parseResetCityCollection,

    timeRanges: parseTimeRanges,

    baggage: parseBaggage,

    airlines: parseAirlineCollection,

    stopoverDuration: parseStopoverDuration,
};

const parserFilterFunctions = {
    time: parseTime,

    baggage: parseBaggage,

    timeRanges: parseTimeRanges,

    stopoverQuantity: Odigeo._.partial(parseFilterData, 'stopoverQuantity'),

    stopoverDuration: parseStopoverDuration,

    stopoverConnection: Odigeo._.partial(parseFilterData, 'stopoverConnection'),

    airlines(msg, index) {
        return Odigeo._.extend(parseFilterData('airlines', msg, index), parseAirlineCollection(msg, index));
    },

    flightDuration: Odigeo._.partial(parseFilterData, 'flightDuration'),
};

const parseFilterMetaData = function(parserFunctions, msg, options) {
    return Odigeo._.reduce([
        'timeRanges',
        'time',
        'stopoverQuantity',
        'stopoverDuration',
        'stopoverConnection',
        'airports',
        'airlines',
        'flightDuration',
        'baggage',
    ], function(data, filter) {
        const stepIndexes = Odigeo._.range(computeFilterLegs(filter, options.tripType, options.numLegs));
        const obj = {};
        obj[filter] = Odigeo._.map(stepIndexes, Odigeo._.partial(parserFunctions[filter] || Odigeo._.constant({}), msg));
        return Odigeo._.extend(data, obj);
    }, {});
};

module.exports = {
    parserResetMetadata: Odigeo._.partial(parseFilterMetaData, parserResetFunctions),
    parseFilterMetadata: Odigeo._.partial(parseFilterMetaData, parserFilterFunctions),
    parseFilterTimeMetadata: parserFilterFunctions.time,
};
